/*
 * Verbatim from @equip.health/ui DatePickerV2 except where noted as [mobile-web addition].
 * Source: https://github.com/equiphealth/equip-ui/blob/main/src/components/DatePickerV2/datePickerV2.css
 *
 * Chakra CSS variables replaced with local CSS custom properties mapped to ColorToken values.
 */

:root {
  --color-neutral-background-primary: #ffffff;
  --color-neutral-line: #e6e8ed;
  --color-neutral-primary: #1e2026;
  --color-neutral-secondary: #585d69;
  --color-neutral-tertiary: #b2b6c1;
  --color-primary-10: #e7fdf9;
  --color-primary-100: #007f79;
  --font-family-body: "Pangea Text", sans-serif;
}

/* [mobile-web addition] Changed flex-direction to row for side-by-side time */
.react-datepicker {
  border: none;
  background-color: var(--color-neutral-background-primary);
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 auto;
  font-family: var(--font-family-body);
}

/* [mobile-web addition] Stack the time under the calendar once the window is too narrow to fit them side by side. */
@media (max-width: 450px) {
  .react-datepicker {
    flex-direction: column;
    align-items: center;
  }

  /* Divider moves from the left of the side-by-side time list to the top when stacked. */
  .react-datepicker__time-container {
    border-left: none;
    border-top: 1px solid var(--color-neutral-line);
    width: 100%;
    margin-top: 12px;
    padding-top: 12px;
  }
}

/* [mobile-web addition] Constrain calendar width when time panel is beside it */
.react-datepicker__month-container {
  width: 284px;
}

.react-datepicker__triangle {
  display: none;
}

.react-datepicker__header {
  background-color: var(--color-neutral-background-primary);
  border: none;
  padding: 0;
}

.react-datepicker__navigation {
  top: 16px;
}

.react-datepicker__navigation--previous {
  left: 16px;
}

.react-datepicker__navigation--next {
  right: 16px;
}

.react-datepicker__navigation-icon::before {
  border-color: var(--color-primary-100);
  border-width: 2px 2px 0 0;
}

.react-datepicker__navigation:hover > .react-datepicker__navigation-icon::before {
  border-color: var(--color-primary-100);
}

.react-datepicker__current-month {
  font-family: var(--font-family-body);
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: -0.45px;
  margin-bottom: 12px;
}

.react-datepicker__day-names {
  display: flex;
}

.react-datepicker__day-name {
  font-family: var(--font-family-body);
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: -0.39px;
  color: var(--color-neutral-secondary);
  height: 36px;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.react-datepicker__month {
  margin: 8px 0 0;
}

.react-datepicker__week {
  display: flex;
}

.react-datepicker__day {
  font-family: var(--font-family-body);
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: -0.39px;
  color: var(--color-neutral-primary);
  height: 36px;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  border-radius: 100%;
  transition: color 0.3s ease-in-out;
}

.react-datepicker__day:hover {
  background-color: var(--color-neutral-background-primary);
  color: var(--color-primary-100);
}

.react-datepicker__day--today,
.react-datepicker__day--today:hover {
  border-radius: 100%;
  background-color: var(--color-primary-10);
}

.react-datepicker__day--selected,
.react-datepicker__day--selected:hover {
  border-radius: 100%;
  background-color: var(--color-primary-100);
  color: var(--color-neutral-background-primary);
}

.react-datepicker__day--disabled,
.react-datepicker__day--disabled:hover {
  color: var(--color-neutral-tertiary);
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__day--keyboard-selected:hover {
  border-radius: 100%;
  background-color: var(--color-neutral-background-primary);
  color: var(--color-neutral-primary);
}

.react-datepicker__day--keyboard-selected.react-datepicker__day--disabled,
.react-datepicker__day--keyboard-selected.react-datepicker__day--disabled:hover {
  background-color: transparent;
  color: var(--color-neutral-tertiary);
}

/* [mobile-web addition] */
.react-datepicker__day--outside-month {
  color: var(--color-neutral-tertiary);
}

/* [mobile-web addition] Side-by-side time panel */
.react-datepicker__time-container {
  border-left: 1px solid var(--color-neutral-line);
  width: 100px;
}

/* [mobile-web addition] Constrain height for bottom-sheet context */
.react-datepicker__time-container .react-datepicker__time {
  max-height: 260px;
  overflow-y: auto;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  text-transform: lowercase;
  font-size: 15px;
  font-family: var(--font-family-body);
  display: flex;
  align-items: center;
  justify-content: center;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: var(--color-primary-100);
  color: var(--color-neutral-background-primary);
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: var(--color-primary-100);
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  background-color: var(--color-primary-10);
}

.react-datepicker.react-datepicker--time-only {
  width: fit-content;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  width: fit-content;
}

/* [mobile-web addition] Style the free-form time input to match picker typography */
.react-datepicker__input-time-container {
  margin: 16px 0 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* [mobile-web addition] */
.react-datepicker__input-time-container .react-datepicker-time__caption {
  font-family: var(--font-family-body);
  font-size: 13px;
  font-weight: 500;
  color: var(--color-neutral-secondary);
}

/* [mobile-web addition] */
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"] {
  font-family: var(--font-family-body);
  font-size: 15px;
  font-weight: 500;
  color: var(--color-neutral-primary);
  border: 1px solid var(--color-neutral-line);
  border-radius: 12px;
  padding: 8px 12px;
  outline: none;
  transition: border-color 0.2s ease;
}

/* [mobile-web addition] */
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"]:focus {
  border-color: var(--color-primary-100);
}
